module.exports = __webpack_public_path__ + "img/zy-zj-card.c71e4f3b.png";